import React, { MouseEventHandler } from 'react';
import { Box, Text, BoxProps } from 'grommet';
import { Row, Col, Card, CardImg, CardText, CardBody } from 'reactstrap';
import { VideoInfo } from '../models/VideoInfo'

interface ISummaryCardProps extends BoxProps {
    key: string;
    text?: string;
    image?: string;
    showTime?: boolean;
    showDescription?: boolean;
    showLanguage?: boolean;
    description?: any;
    data?: VideoInfo;
    onClick?: MouseEventHandler<HTMLDivElement>;
};

// type SummaryCardProps = ISummaryCardProps;

export default class SummaryCard extends React.PureComponent<ISummaryCardProps> {
    render() {
        let video = this.props.data;
        let audioLanguages = video?.audioLanguages.map((audioLanguage, ndx) => {
            return <Text size='xsmall' key={`al-${ndx}`}>{audioLanguage}</Text>;
        });

        return <Box flex="grow" height={{ max: "large" }} direction='row' {...this.props}  >
            <Card className="w-100" >
                <Row className="no-gutters">
                    <Col xs="3" frameBorder="" >
                        <Box height="xxsmall" pad={{ top: "xsmall", left: "xsmall" }}>
                            <CardImg className="h-100" style={{ backgroundColor: "black" }} src={video?.thumbnailImage ?? this.props.image} />
                            {this.props.showTime && <div className="duration">
                                <span className="timeCode">{video?.length}</span>
                            </div>}
                            {video?.isPodcast && <div className="podcast">
                                <span className="podcast-label">Podcast</span>
                            </div>}
                        </Box>
                    </Col>
                    <Col xs="9">
                        <CardBody className="p-1">
                            <CardText>
                                <Text size="xsmall" color="brand" weight="bold">{video?.name ?? this.props.text}</Text>
                            </CardText>
                        </CardBody>
                    </Col>
                </Row>
                <Row className="p-2">
                    <Col xs="12">
                        {video && <Box>
                            {this.props.showLanguage && <Box>
                                {audioLanguages}
                            </Box>}
                            {this.props.showDescription && <Text size='xsmall'>{video?.description}</Text>}
                        </Box>}
                        {this.props.showDescription && this.props.description && <Text size="xsmall">{this.props.description}</Text>}
                    </Col>
                </Row>
            </Card>
        </Box>;
    }
}
